export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_ASSIGN_MODAL = 'OPEN_ASSIGN_MODAL';
export const OPEN_MARK_NOSHOW = 'OPEN_MARK_NOSHOW';
export const OPEN_SUB_REQUEST = 'OPEN_SUB_REQUEST';
export const OPEN_IMAGE_PREVIEW = 'OPEN_IMAGE_PREVIEW';
